import { render, staticRenderFns } from "./GroupsStep.vue?vue&type=template&id=0e81fc6d&scoped=true"
import script from "./GroupsStep.vue?vue&type=script&lang=js"
export * from "./GroupsStep.vue?vue&type=script&lang=js"
import style0 from "./GroupsStep.vue?vue&type=style&index=0&id=0e81fc6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e81fc6d",
  null
  
)

export default component.exports